"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MySpecialPurchaseInitRequest = void 0;
var MySpecialPurchaseInitRequest = /** @class */ (function () {
    function MySpecialPurchaseInitRequest() {
    }
    return MySpecialPurchaseInitRequest;
}());
exports.MySpecialPurchaseInitRequest = MySpecialPurchaseInitRequest;
;
//# sourceMappingURL=mySpecialPurchaseInit.request.js.map